import React from 'react';
import '../../styles/offernowaz.css';

const OfferNowAZThankYou: React.FC = () => {
  return (
    <div className="offernowaz-container">
      <div className="container">
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '80px 20px',
          textAlign: 'center'
        }}>
          <div style={{
            backgroundColor: '#48bb78',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: '40px'
          }}>
            ✓
          </div>
          
          <h1 style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#1a202c',
            marginBottom: '16px'
          }}>
            Thank You!
          </h1>
          
          <p style={{
            fontSize: '1.5rem',
            color: '#4a5568',
            marginBottom: '32px'
          }}>
            We've received your property information.
          </p>
          
          <div style={{
            backgroundColor: '#ebf8ff',
            padding: '32px',
            borderRadius: '8px',
            marginBottom: '48px'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              What Happens Next?
            </h2>
            
            <div style={{ textAlign: 'left', maxWidth: '600px', margin: '0 auto' }}>
              <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-start' }}>
                <span style={{ color: '#2b6cb0', fontWeight: 'bold', marginRight: '8px' }}>1.</span>
                <p style={{ margin: 0, color: '#4a5568' }}>
                  Our team will review your property information and recent comparable sales in your area.
                </p>
              </div>
              
              <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-start' }}>
                <span style={{ color: '#2b6cb0', fontWeight: 'bold', marginRight: '8px' }}>2.</span>
                <p style={{ margin: 0, color: '#4a5568' }}>
                  Within 24 hours, we'll contact you with a no-obligation cash offer.
                </p>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <span style={{ color: '#2b6cb0', fontWeight: 'bold', marginRight: '8px' }}>3.</span>
                <p style={{ margin: 0, color: '#4a5568' }}>
                  If you accept our offer, we can close in as little as 7 days - on your timeline.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{ marginBottom: '48px' }}>
            <p style={{ color: '#4a5568', marginBottom: '16px' }}>
              Have questions? Call us directly:
            </p>
            <a 
              href="tel:+14805551234" 
              style={{
                display: 'inline-block',
                backgroundColor: '#2b6cb0',
                color: 'white',
                fontWeight: '700',
                padding: '16px 32px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontSize: '1.125rem'
              }}
            >
              (480) 555-1234
            </a>
          </div>
          
          <div>
            <a 
              href="/" 
              style={{
                color: '#2b6cb0',
                textDecoration: 'none',
                fontWeight: '600'
              }}
            >
              ← Return to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferNowAZThankYou;